import React from "react";
import PuzzlePiece from "./PuzzlePiece";

const F = { fontFamily: "'Fredoka', sans-serif" };

/**
 * The piece bank below the board. Shows every piece not yet on the board; each
 * can be dragged onto any slot. While the picture is being composited/sliced a
 * friendly "Cutting the pieces…" chip appears.
 */
const PuzzleTray = ({
  bank,
  grid,
  tile,
  boardImage,
  composited,
  disabled,
  draggingPiece,
  preparing,
  onPiecePointerDown,
}) => {
  return (
    <div
      className="relative mx-1 mt-3 rounded-[22px] p-2.5 sm:mx-2 sm:p-3"
      style={{
        minHeight: tile * 1.6 + 24,
        background: "rgba(255,255,255,0.6)",
        border: "1px solid rgba(24,153,112,0.14)",
        boxShadow: "0 5px 16px rgba(24,112,85,0.1)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        {bank.map((piece) => (
          <div
            key={`bank-${piece}`}
            role="button"
            aria-label={`Puzzle piece ${piece + 1}`}
            onPointerDown={disabled ? undefined : (e) => onPiecePointerDown(e, piece, { kind: "bank" })}
            className="touch-none"
            style={{ cursor: disabled ? "default" : "grab", opacity: draggingPiece === piece ? 0 : 1 }}
          >
            <PuzzlePiece
              boardImage={boardImage}
              composited={composited}
              index={piece}
              grid={grid}
              tile={tile}
              lifted={false}
            />
          </div>
        ))}
        {!bank.length && !preparing && (
          <p
            className="rounded-full bg-white/80 px-4 py-2 text-center text-sm font-semibold"
            style={{ ...F, color: "#189970" }}
          >
            All pieces placed!
          </p>
        )}
      </div>

      {preparing && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="flex items-center gap-2 rounded-full bg-white px-4 py-2"
            style={{ boxShadow: "0 6px 14px rgba(11,26,51,0.1)" }}
          >
            <span
              className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-[#189970]/30 border-t-[#189970]"
              aria-hidden
            />
            <span className="text-sm font-semibold" style={{ ...F, color: "#5D7695" }}>
              Cutting the pieces…
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PuzzleTray;
